// extracted by mini-css-extract-plugin
export var changeIcon = "_4s-4";
export var container = "_4s-0";
export var divider = "_4s-7";
export var externalLinkIcon = "_4s-1";
export var green = "_4s-5";
export var helpCircleIcon = "_4s-3";
export var iconButton = "_4s-2";
export var red = "_4s-6";